module.exports = __webpack_public_path__ + "img/logo.a70cdd54.jpg";